var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-md w-full md:w-2/4 relative" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.searchInput,
          expression: "searchInput",
        },
      ],
      staticClass: "form__input h-lg form__input--filled",
      attrs: { autofocus: "", type: "text", placeholder: _vm.placeholder },
      domProps: { value: _vm.searchInput },
      on: {
        keyup: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onArrowDown()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onArrowUp()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnter.apply(null, arguments)
          },
          _vm.getRecipes,
        ],
        focus: function ($event) {
          _vm.show = true
        },
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.searchInput = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-700 cursor-pointer",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.goTo.apply(null, arguments)
          },
        },
      },
      [_c("i", { staticClass: "fa-regular fa-search" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.hideDropdown,
            expression: "hideDropdown",
          },
          {
            name: "show",
            rawName: "v-show",
            value: _vm.recipes.length > 0 && _vm.show,
            expression: "recipes.length > 0 && show",
          },
        ],
        key: _vm.selectedIndex + "/" + _vm.hoverinIndex,
        staticClass:
          "absolute left-0 w-full top-lg h-auto overflow-y-auto bg-gray-200",
      },
      [
        _vm._l(_vm.recipes, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              on: {
                mouseover: function ($event) {
                  return _vm.setIndex(index)
                },
                mouseleave: function ($event) {
                  return _vm.clearIndex()
                },
              },
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "flex items-center justify-between py-xs border-b border-gray-200 text-gray-600 text-sm px-sm font-normal",
                  class: {
                    "bg-gray-300 !font-bold":
                      _vm.hoverinIndex === index ||
                      (index === _vm.selectedIndex && _vm.hoverinIndex === -1),
                  },
                  attrs: {
                    href: _vm.possibleLangPrefix + "/recepten/" + item.slug,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(item.title) +
                      "\n                "
                  ),
                  _vm.hoverinIndex === index ||
                  (index === _vm.selectedIndex && _vm.hoverinIndex === -1)
                    ? _c("i", { staticClass: "fa-regular fa-arrow-right" })
                    : _vm._e(),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _vm.recipes && _vm.recipes.length >= 3
          ? _c(
              "div",
              {
                on: {
                  mouseover: function ($event) {
                    return _vm.setIndex(3)
                  },
                  mouseleave: function ($event) {
                    return _vm.clearIndex()
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "flex items-center bg-gray-300 justify-between py-xs border-b border-gray-200 text-gray-600 text-sm px-sm",
                    class: {
                      "font-bold":
                        _vm.hoverinIndex === 3 ||
                        (3 === _vm.selectedIndex && _vm.hoverinIndex === -1),
                    },
                    attrs: {
                      href:
                        _vm.possibleLangPrefix +
                        "/recepten?s=" +
                        this.searchInput,
                    },
                  },
                  [
                    _vm._v(
                      "\n                Bekijk alle zoekresultaten\n                "
                    ),
                    _vm.hoverinIndex === 3 ||
                    (3 === _vm.selectedIndex && _vm.hoverinIndex === -1)
                      ? _c("i", { staticClass: "fa-regular fa-arrow-right" })
                      : _vm._e(),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }